import { Helmet } from 'react-helmet';
import type { VoidFunctionComponent } from 'react';

import { GLOBAL_LICENSE_CORRECTIONS, MANUAL_MALWARE, VULN_ADMIN } from '../../../shared/featureFlags/flagNames';
import { CacheKind } from '../../../shared/InternalTools/cache';
import { window } from '../../globals';
import CallToAction from '../CallToAction';
import Flex from '../generic/Flex';
import FeatureFlagRequired from '../generic/Gates/FeatureFlagRequired';
import PageHeadingBreadcrumbs from '../generic/PageHeadingBreadcrumbs';
import Text from '../generic/Text';

import BuildLocatorsComponent from './BuildLocatorsComponent';
import FaktoryInfo from './FaktoryInfo';
import InvalidateCacheComponent from './InvalidateCacheComponent';
import LicenseCorrectionCard from './LicenseCorrectionCard/LicenseCorrectionCard';
import ManualMalwareComponent from './ManualMalware';
import OnPremOrgsComponent from './OnPremOrgsComponent';
import OrganizationCard from './OrganizationCard';
import EnrichMetadataComponent from './security/EnrichMetadataComponent';
import RecalculateVulnsComponent from './security/RecalculateVulnsComponent';
import UserCard from './UserCard';

/**
 * Container for the internal tools page.
 */
const InternalToolsPage: VoidFunctionComponent = () => (
  <>
    <CallToAction>
      <PageHeadingBreadcrumbs
        truncateAt={80}
        crumbs={[
          {
            to: '/internal-tools',
            text: 'Internal Tools',
          },
          {
            text: window.user?.organization?.title ?? 'Organization',
          },
        ]}
      />
    </CallToAction>
    <div className="container margin-top">
      <Helmet title="Internal Tools" />
      <div className="alert">
        Stuff on this page can have catastrophic effects if used incorrectly. Make sure you know what you&apos;re doing.
      </div>
      <div className="internal-tools">
        <Flex direction="column" gap={12}>
          <OrganizationCard />
          <UserCard />
          <OnPremOrgsComponent />
          <InvalidateCacheComponent cacheKinds={Object.values(CacheKind)} />
          <BuildLocatorsComponent />
          <FeatureFlagRequired flagName={MANUAL_MALWARE}>
            <ManualMalwareComponent />
          </FeatureFlagRequired>
          <FeatureFlagRequired flagName={GLOBAL_LICENSE_CORRECTIONS}>
            <LicenseCorrectionCard />
          </FeatureFlagRequired>
          <FaktoryInfo />
          <FeatureFlagRequired flagName={VULN_ADMIN}>
            <Text.H1>Vulns Tools</Text.H1>
            <div className="internal-tools__vulns">
              <EnrichMetadataComponent type="revision" supportedFetchers={['npm', 'pip', 'mvn']} />
              <RecalculateVulnsComponent />
            </div>
          </FeatureFlagRequired>
        </Flex>
      </div>
    </div>
  </>
);

export default InternalToolsPage;
